import styled from 'styled-components'

export const BelowTheBoxGroup = styled.div`
  margin-top: 10px;
  width: 464px;
`
